import React from 'react';
import { useBannerAssets } from '@/shared/hooks/useBannerAssets';
import { ResponsiveBannerImage } from '@/shared/ui/responsive-banner-image';
import { BannerStyle } from './styles';

export const BonusBanner = () => {
  const bannerAssets = useBannerAssets('homeBanner');

  if (!bannerAssets) {
    return null;
  }

  return (
    <BannerStyle>
      <ResponsiveBannerImage
        desktopSrc={bannerAssets.default}
        mobileSrc={bannerAssets.mobile}
        alt="Registration bonus"
        fetchPriority="high"
      />
    </BannerStyle>
  );
};
